// we need to use any so that `includes` wont complain about
// `value` type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function includes<T>(arr: readonly T[], value: any): value is T {
    return arr.includes(value);
}
